// How to reach us: the support line's number and the support email, one copy for
// both apps, the web dashboard and the website.
//
// ⛔ No phone opening hours anywhere a customer looks (founder 2026-10-19): the
// apps, the dashboard and the website show Call us with the number and nothing
// else, no hours and no Closed state, because the line is always answered. Only
// the call itself knows the team's hours, when it puts someone through
// (servers/onboarding lib/callCentre isOpenNow). Do not bring hours back here.
// The file keeps its name so every import of the number still resolves.
export const SUPPORT_PHONE_DISPLAY = '+44 (0)330 912 7848'
export const SUPPORT_PHONE_TEL     = '+443309127848'
// The same number the UK way, for the website: "0330 912 7848". Derived, so the
// number lives once (SUPPORT_PHONE_TEL) and the two can never disagree.
export const SUPPORT_PHONE_NATIONAL = SUPPORT_PHONE_TEL.replace(/^\+44(\d{3})(\d{3})(\d{4})$/, '0$1 $2 $3')
export const SUPPORT_EMAIL         = 'support@tempdash.app'
// Where to write to us: the company name and registered office exactly as the terms give them
// (worker and Business terms header). Shown on Other ways to contact us, nowhere else.
export const SUPPORT_ADDRESS       = 'TempDash Ltd, 124 City Rd, London EC1V 2NX'
